import { PropsWithChildren, useState } from 'react'

import ComponentSize from '../../ComponentSize'
import { ListVariantContext } from './Context'
import ListVariantComponentType from './ListVariantComponent'

const localStorageTypeName = 'listVariantType'
const localStorageSizeName = 'listVariantSize'

const getTypeFromLocalStorage = (defaultValue?: ListVariantComponentType) => {
  const storedItem = localStorage.getItem(localStorageTypeName)
  switch (storedItem) {
    case ListVariantComponentType.Bar:
      return ListVariantComponentType.Bar
    case ListVariantComponentType.Card:
      return ListVariantComponentType.Card
    default:
      return defaultValue
  }
}

const getSizeFromLocalStorage = (defaultValue?: ComponentSize) => {
  return (localStorage.getItem(localStorageSizeName) ?? defaultValue) as ComponentSize
}

interface Props {
  defaultComponent?: ListVariantComponentType
  defaultSize?: ComponentSize
}

export const ListVariantLoader: React.FC<PropsWithChildren<Props>> = (props) => {
  const { defaultSize, defaultComponent, children } = props
  const [size, setSize] = useState<ComponentSize>(getSizeFromLocalStorage(defaultSize ?? 'medium'))
  const [componentType, setComponentType] = useState(getTypeFromLocalStorage(defaultComponent ?? ListVariantComponentType.Bar))

  const update = (component: ListVariantComponentType, size?: ComponentSize) => {
    setComponentType(component)
    setSize(size ?? 'medium')
    localStorage.setItem(localStorageTypeName, component)
    localStorage.setItem(localStorageSizeName, size ?? 'medium')
  }

  return <ListVariantContext.Provider value={{ componentType, size, update }}>{children}</ListVariantContext.Provider>
}
